


















































































































import Vue from "vue";
import ProjectDetailsOverlay from "@/components/ProjectDetailsOverlay.vue";
import gameProjectsData from "@/data/GameProjectsData.ts";
import ProjectData from "@/data/ProjectData.ts";

export default Vue.extend({
  name: "Resume",
  components: {
    ProjectDetailsOverlay,
  },
  data: function () {
    return {
      showPopup: false,
      popupTitle: "",
      popupColor: "#000000",
      popupContent: "",
      projects: [
        {
          id: "drag-rush",
          name: "Drag Rush",
          meta: "Unity · C# · 8wk · team of 6",
          summary: "Built animation trees for the vehicles. Helped with overhauling our beat conductor for better BPM precision. Also did level design.",
        },
        {
          id: "dispater",
          name: "Dispater",
          meta: "Unreal · C++ · 8wk · team of 7",
          summary: "Built the systems that drive the story forward, including dialogue, voice lines, tasks, interactions.",
        },
        {
          id: "floor-0",
          name: "Floor Zero",
          meta: "Unreal · UE Blueprint · 5wk · solo",
          summary: "Made a modular interaction interface, together with a key/door system. Built a competent AI using UE's NavMesh.",
        },
        {
          id: "swing-space",
          name: "SwingSpace",
          meta: "Unity · C# · 5wk · solo",
          summary: "First solo project. Built a swing mechanic and hooked up a live global leaderboard with Firebase.",
        },
      ],
      // Condensed variants, rendered only when the ?pdf=1 flag is present
      // (scripts/export-resume-pdf.js navigates with that flag). These keep
      // the exported PDF at one page while the live /resume route shows the
      // full content above. See Beyond the Code below for the other half
      // of this split — that section is skipped entirely in PDF mode.
      projectsPdf: [
        {
          id: "drag-rush",
          name: "Drag Rush",
          summary: "Built animation trees for the vehicles. Helped overhaul our beat conductor for better BPM precision. Also did level design.",
        },
        {
          id: "dispater",
          name: "Dispater",
          summary: "Built the systems that drive the story forward, including dialogue, voice lines, tasks, and interactions.",
        },
        {
          id: "floor-0",
          name: "Floor Zero",
          summary: "Made a modular interaction interface, together with a key/door system. Built a competent AI using UE's NavMesh.",
        },
        {
          id: "swing-space",
          name: "SwingSpace",
          summary: "First solo project. Built a swing mechanic and hooked up a live global leaderboard with Firebase.",
        },
      ],
      experience: [
        {
          org: "Wet Dog",
          role: "Co-Founder",
          period: "2019-24",
          detail: "Ran an independent business for 5 years. Planning, budget, partnerships.",
        },
        {
          org: "Axel Arigato",
          role: "Sales / Assistant Manager",
          period: "2018-now",
          detail: "KPI-driven retail operations in a fast-paced environment.",
        },
      ],
      education: [
        {
          org: "YRGO",
          role: "Game Programming",
          period: "25-27",
        },
        {
          org: "Nordiska Textilakademin",
          role: "Textile Buyer",
          period: "19-22",
        },
      ],
      techStack: ["Unity", "C#", "Unreal", "C++", "UE Blueprint", "Git"],
      personal: [
        {
          label: "Esports",
          detail: "Previously Top 500 in Overwatch, mainly playing Ana support.",
        },
        {
          label: "Current favorites",
          detail: "Zelda: A Link to the Past, RE9, TLOS 2, and Dead Cells.",
        },
        {
          label: "Anime",
          detail: "Fan since I was 8, when I found a Dragon Ball at my local library. Some of my favs: Gachiakuta, Chainsaw Man, and JoJo's.",
        },
        {
          label: "Off the PC",
          detail: "Running, or taking walks in the woods.",
        },
        {
          label: "Music",
          detail: "Sang, rapped, and produced with a group of friends throughout my teenage years. A part of my life that's close to my heart.",
        },
      ],
    };
  },
  computed: {
    isPdf: function (): boolean {
      return this.$route.query.pdf === "1";
    },
    activeProjects: function (): { id: string; name: string; meta?: string; summary: string }[] {
      return this.$route.query.pdf === "1" ? this.projectsPdf : this.projects;
    },
  },
  methods: {
    showDetails: function (id: string) {
      const item = gameProjectsData.find((p: ProjectData) => p.id === id);
      if (!item) {
        return;
      }
      this.popupTitle = item.name;
      this.popupColor = item.accentColor;
      this.popupContent = item.htmlDescription;
      this.showPopup = true;
    },
  },
});
